import { Component, Input, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-level-increment',
  templateUrl: './select-level-increment.component.html',
  styleUrls: ['./select-level-increment.component.scss']
})
export class SelectLevelIncrementComponent implements OnDestroy {

  @Input() section: any = false;
  @Input() productType: string = 'regular';
  first = true;

  public items: any[] = [
    { name: 'Nivel 1', value: '1' },
    { name: 'Nivel 2', value: '2' },
    { name: 'Nivel 3', value: '3' },
    { name: 'Nivel 4', value: '4' },
    { name: 'Nivel 5', value: '5' },
    { name: 'Sin Increm', value: '0' },
  ];

  public levelIncrement: any = [];
  public ngxDisabled = this.productType == 'regular';
  levelIncrement$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.levelIncrement$ = this.sharedService.sharedLevelIncrement.subscribe(levelIncrement => {
      this.levelIncrement = levelIncrement;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.levelIncrement$.unsubscribe();
  }

  ngOnChanges(){
      this.ngxDisabled = this.productType === 'regular';
      if(this.ngxDisabled){
        this.levelIncrement = '0';
      }
  }
  changelevelIncrement(event: any) {
    this.levelIncrement = event;
    this.sharedService.nextLevelIncrement = this.levelIncrement;
  }
}
